<ng-container *ngIf="field">
	<div class="flex-auto container-switch input-field-container" [class]="field.customClass">

		<label [for]="field.UIOptions?.SwitchComponentOptions?.removeLinkLabel ? null : field.Name"
			*ngIf="field.UIOptions?.SwitchComponentOptions; else simpleLabel">
			<span *ngIf="field.UIOptions?.showLabel">{{ fieldOptions.label || field.DisplayText }}</span>
		</label>

		<ng-template #simpleLabel>
			<label [for]="field?.Name" [hidden]="field.UIOptions?.hideLabel">{{ fieldOptions?.label ||
				field?.DisplayText}}</label>
		</ng-template>

		<p-inputSwitch
			[inputId]="field.Name"
			[trueValue]="field.UIOptions?.SwitchComponentOptions?.trueValue || true"
			[falseValue]="field.UIOptions?.SwitchComponentOptions?.falseValue || false"
			[formControl]="control"
			(onChange)="onChange($event)">
		</p-inputSwitch>
	</div>
</ng-container>
